import { linealChannels } from '../requests/loader';
import AAF from 'src/AAF/AAF';
import { LINEAL_CHANNELS_TTL } from 'src/AAF/Resilence/TTLConstants';

export const REQUEST_LINEAL_CHANNELS = 'REQUEST_LINEAL_CHANNELS';
export const RECEIVE_LINEAL_CHANNELS = 'RECEIVE_LINEAL_CHANNELS';

export const requestLinealChannels = () => ({ type: REQUEST_LINEAL_CHANNELS });
export const receiveLinealChannels = (groups) => ({ type: RECEIVE_LINEAL_CHANNELS, data: groups });
const TTLItem = LINEAL_CHANNELS_TTL;

export const fetchLinealChannels = (userId, cb = null, fromTTL = false) => dispatch => {
    dispatch(requestLinealChannels());
    return linealChannels(userId)
      .then(result => {
        const response = result.response ? result.response : false;
        const paqs = (response && response.paqs && response.paqs.paq) || [];
        const channelsData = paqs.reduce((prev, paq) => {
          const ch = paq.groups.split(',').map(c => {
            return {
              id: c,
              paq: paq.name,
              offerid: paq.offerid,
              purchaseid: paq.purchaseid,
              npvrstorage: !isNaN(parseInt(paq.npvrstorage)) ? parseInt(paq.npvrstorage) : 0,
              timeshift: !isNaN(parseInt(paq.timeshift)) ? parseInt(paq.timeshift) : 0,
              npvr_token: paq.payway_token,
              timeshift_token: paq.payway_token,
              play: paq.play === '1',
              key: paq.key,
            }
          });
          return [...prev, ...ch];
        }, []);
        const channels = channelsData.reduce((prev, channel) => {
          const oldChannelIndex = prev.findIndex(c => c.id == channel.id);
          if (oldChannelIndex !== -1) {
            const newChannel = prev[oldChannelIndex];
            if (newChannel.timeshift < channel.timeshift) {
              newChannel.timeshift = channel.timeshift;
              newChannel.timeshift_token = channel.timeshift_token;
            }
            if (newChannel.npvrstorage < channel.npvrstorage) {
              newChannel.npvrstorage = channel.npvrstorage;
              newChannel.npvr_token = channel.npvr_token;
            }
            if (!newChannel.play && channel.play) newChannel.play = channel.play;
          } else {
            prev.push(channel);
          }
          return prev;
        }, []);
        //console.info("[fetchLinealChannels]", channels);
        dispatch(receiveLinealChannels(channels));
        if (!fromTTL) {
          AAF.TTLUtil.setStorageItemTTL(TTLItem);
        }
        if(typeof cb === 'function'){
          console.log('[fetchLinealChannels] ejecuta cb');
          cb();
        }
      }).catch(error => {
        console.error('[fetchLinealChannels] err', error);
        if(typeof cb === 'function'){
          console.log('[fetchLinealChannels] ejecuta cb');
          cb();
        }
      })
};



// WEBPACK FOOTER //
// ./src/actions/payway.js